import { FC, FormEvent, useRef } from "react"
import { getThreads, ThreadSummary } from "../../services/BoardData"


export type SearchBoxProps = {
  handleSearchResults: (params: { data: Array<ThreadSummary>, isSearching: boolean, errorText: string }) => void
}

const ThreadSearchBox: FC<SearchBoxProps> = ({ handleSearchResults }) => {
  const searchEntryField = useRef<HTMLInputElement>(null)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    handleSearchResults({ data: [], isSearching: true, errorText: '' })
    getThreads({ searchText: searchEntryField?.current?.value || '' })
      .then(data => handleSearchResults({ data, isSearching: false, errorText: '' }))
      .catch((reason: Error) => handleSearchResults({ data: [], isSearching: false, errorText: reason?.message || 'unknown error' }))
  }

  return (
    <div className="w-full flex">
      <form className="p-2 w-full" onSubmit={handleSubmit}>
        <input
          className="w-96"
          type="text"
          placeholder="search threads"
          id="customSearchField"
          ref={searchEntryField}
        />
      </form>

    </div>
  )
}

export default ThreadSearchBox